import type { TOC } from '@ember/component/template-only';
import { array, hash } from '@ember/helper';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import {
  PrismLoadingBar,
  PrismModal,
  PrismTabsContainer,
} from '@mylighthouse/prism-ember';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import GeneralButtonsButtonExport from 'lumen/components/general/buttons/button-export';
import HotelStrategyTabEvolutionGraph from 'lumen/components/hotel/strategy/tab-evolution-graph';
import HotelStrategyTablesTableDetailMembership from 'lumen/components/hotel/strategy/tables/table-detail-membership';
import type HotelStrategyMembershipController from 'lumen/controllers/hotel/strategy/membership';
import { DETAIL_VIEW_TABS } from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyMembershipSignature {
  Args: {
    controller: HotelStrategyMembershipController;
    model: unknown;
  };
}

<template>
  {{! template-lint-disable no-duplicate-id }}
  <PrismModal
    @onClose={{@controller.redirectOnClose}}
    @title={{t "general.member_rates"}}
    {{didInsert @controller.resetContainerDimensions}}
  >
    <:actions>
      <GeneralButtonsButtonExport
        @exportAction={{perform @controller.exportRSTableTask}}
        data-event-id="hotel-rate-strategy-detail-export"
        data-event-value={{@controller.router.currentRoute.localName}}
      />
    </:actions>
    <:default>
      <div>
        {{#if (or @controller.isLoading @controller.isChartLoading)}}
          <div class="relative">
            <PrismLoadingBar />
          </div>
        {{/if}}
        <div class="modal--stretched">
          {{#if @controller.canRender}}
            <PrismTabsContainer
              @activeTabId={{@controller.tab}}
              @onSelectTab={{@controller.makeActiveTab}}
              @visibleTabIds={{array
                DETAIL_VIEW_TABS.TABLE
                DETAIL_VIEW_TABS.GRAPH
              }}
              as |TabsContainer|
            >
              <TabsContainer.header as |Header|>
                <Header.tab @id={{DETAIL_VIEW_TABS.TABLE}}>
                  {{t "general.table"}}
                </Header.tab>
                <Header.tab @id={{DETAIL_VIEW_TABS.GRAPH}}>
                  {{t "general.graph"}}
                </Header.tab>
              </TabsContainer.header>
              <TabsContainer.content as |Content|>
                <Content.tab @id={{DETAIL_VIEW_TABS.TABLE}}>
                  <HotelStrategyTablesTableDetailMembership
                    {{! @glint-expect-error: Incorrect type }}
                    @membershipDataPerHotelInfo={{@controller.membershipDataPerHotelInfo}}
                    @onTableSort={{@controller.onTableSort}}
                    @sortFunction={{@controller.sortFunction}}
                    {{! @glint-expect-error: Incorrect type }}
                    @sorts={{@controller.sorts}}
                    @subtypes={{@controller.subtypes}}
                  />
                </Content.tab>
                <Content.tab @id={{DETAIL_VIEW_TABS.GRAPH}}>
                  <HotelStrategyTabEvolutionGraph
                    @params={{hash
                      chooseEntity=@controller.chooseEntity
                      chooseSubtype=@controller.chooseSubtype
                      entity=@controller.entityToDisplay
                      entityId=@controller.entity
                      formattedDates=@controller.formattedDates
                      formattedHistoricData=@controller.formattedHistoricData
                      height=@controller.height
                      historicData=@controller.historicData
                      isLoading=@controller.isChartLoading
                      offset=@controller.offset
                      subtypeId=@controller.subtypeId
                      subtypes=@controller.subtypes
                      type=@controller.typeId
                      updateOffset=@controller.updateOffset
                      width=@controller.width
                    }}
                  />
                </Content.tab>
              </TabsContainer.content>
            </PrismTabsContainer>
          {{/if}}
        </div>
      </div>
    </:default>
  </PrismModal>
</template> satisfies TOC<HotelStrategyMembershipSignature>;
